/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BlockquoteDefaultExample, BlockquoteGraphicsExample, BlockquoteTransparentExample, BlockquoteTransparentOnTopExample} from 'Docs/uilib/elements/blockquote/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Blockquote"
    }), "\n", _jsx(_components.h2, {
      children: "Default Blockquote"
    }), "\n", _jsx(BlockquoteDefaultExample, {}), "\n", _jsx(_components.h2, {
      children: "Blockquote with graphics on top"
    }), "\n", _jsx(BlockquoteGraphicsExample, {}), "\n", _jsxs(_components.h2, {
      children: ["Blockquote with transparent background (", _jsx(_components.code, {
        children: "no-background"
      }), ")"]
    }), "\n", _jsx(BlockquoteTransparentExample, {}), "\n", _jsx(_components.h2, {
      children: "Blockquote with transparent background and graphics on top"
    }), "\n", _jsx(BlockquoteTransparentOnTopExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
